<div
  class="modal fade"
  id="confirmCancelModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Confirm Cancellation</h5>
      </div>

      <div class="modal-body">
        @if (
          (orderType === cancelOperationType.MovementOrder &&
            status === movementOrderStatus.WorkInProgress) ||
          (orderType === cancelOperationType.TransferOrder &&
            status === transferOrderStatus.InProgress)
        ) {
          <p class="bold-text">
            This <b>"{{ referenceNumber }}"</b>
            {{
              orderType === cancelOperationType.MovementOrder ? 'Movement Order' : 'Transfer Order'
            }}
            is currently
            <strong>{{
              orderType === cancelOperationType.MovementOrder ? 'Work In Progress' : 'In Progress'
            }}</strong
            >. Are you sure you want to <strong>Cancel</strong> it?
          </p>
        } @else {
          <p class="bold-text">
            Are you sure you want to cancel
            <b>"{{ referenceNumber }}"</b>
            {{ orderType | enumLabel: cancelOperationType }}?
          </p>
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="cancel-btn btn me-2" data-bs-dismiss="modal">Cancel</button>

        <button
          type="button"
          class="primary-btn btn ms-2"
          (click)="onConfirm()"
          data-bs-dismiss="modal"
        >
          Yes, Cancel
        </button>
      </div>
    </div>
  </div>
</div>
